export default "__VITE_ASSET__326cea3d__"